import React, { useEffect, useRef, useState } from "react";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ClearIcon from "@mui/icons-material/Clear";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import facebookIcon from "../assets/icons/facebook.svg";
import xIcon from "../assets/icons/x.svg";
import instagramIcon from "../assets/icons/instagram.svg";
import linkedinIcon from "../assets/icons/linkedin.svg";
import { TextField } from "@mui/material";

export default function MyAccount() {
  const [data, setData] = useState({});
  const [show, setShow] = useState(false);
  const [image, setImage] = useState();
  const [certif, setCertif] = useState([""]);
  const [socials, setSocials] = useState({ fb: "", x: "", li: "", ig: "" });
  let userToken = localStorage.getItem("userToken");
  const hiddenFileInput = useRef();
  const hiddenFileInput2 = useRef();

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(`${API}/users/me?populate=*`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const res = await response.json();
        setData(res);
        setSocials(res.socials ? res.socials : {});

        let cerDocs = [...res.certificates];
        cerDocs.push("");
        setCertif(cerDocs);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData();
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
    }
  };
  const handleAddCertif = (e) => {
    const newCertif = [...certif];
    newCertif.splice(certif.length - 1, 0, e.target.files[0]);

    setCertif(newCertif);
  };

  const handleRemoveCertif = (index) => {
    const newCertif = certif.filter((_, i) => i !== index);
    setCertif(newCertif);
  };

  const submitData = async () => {
    // Initialize formData for certificates
    const formData = new FormData();
    let hasFilesToUpload = false;

    // Check if there are certificate files to upload and append them to formData
    certif.forEach((item) => {
      if (item instanceof File) {
        formData.append("files", item);
        hasFilesToUpload = true;
      }
    });

    // Separate formData for the profile picture
    const pfpFormData = new FormData();
    let hasPfpToUpload = false;

    // Check if there is a new profile picture to upload
    if (image instanceof File) {
      pfpFormData.append("files", image);
      hasPfpToUpload = true;
    }

    try {
      let uploadedUrls = [];
      let uploadedPfpUrl = null;

      // If there are certificate files to upload, perform the upload
      if (hasFilesToUpload) {
        const uploadResponse = await fetch(`${API}/upload`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
          body: formData,
        });

        if (!uploadResponse.ok) {
          throw new Error("Failed to upload files");
        }

        const uploadedFiles = await uploadResponse.json();
        uploadedUrls = uploadedFiles.map((file) => file.url);
      }

      // If there is a profile picture to upload, perform the upload
      if (hasPfpToUpload) {
        const pfpUploadResponse = await fetch(`${API}/upload`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
          body: pfpFormData,
        });

        if (!pfpUploadResponse.ok) {
          throw new Error("Failed to upload profile picture");
        }

        const uploadedPfpFile = await pfpUploadResponse.json();
        uploadedPfpUrl = uploadedPfpFile[0]?.url || null; // Get the URL of the uploaded profile picture
      }

      // Filter out the deleted URLs from data.certificates
      const remainingCertificates = data.certificates?.filter((url) =>
        certif.includes(url)
      );

      // Combine old remaining and new uploaded certificates
      const combinedCertificates = [...remainingCertificates, ...uploadedUrls];

      // Prepare data object with the combined certificates and the new profile picture
      const dataToUpdate = {
        gender: data.gender,
        birthday: data.birthday,
        languages: data.languages,
        education: data.education,
        bio: data.bio,
        certificates: combinedCertificates,
        pfp: uploadedPfpUrl || "",
        socials: socials,
      };

      // Update user profile with the combined data
      const updateResponse = await fetch(`${API}/user/updateLoggedInUser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({ data: dataToUpdate }),
      });

      if (!updateResponse.ok) {
        throw new Error("Failed to update user data");
      } else {
        setShow(true);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const logOut = () => {
    localStorage.removeItem("userToken");
    window.location.reload();
  };

  return (
    <div className="flex-col">
      <div className="flex-col" style={{ position: "relative" }}>
        <img
          style={{
            width: 140,
            aspectRatio: 1,
            borderRadius: 70,
            objectFit: "cover",
          }}
          src={
            image
              ? URL.createObjectURL(image)
              : data.pfp
              ? SERVER_DOMAIN + data.pfp
              : "https://cdn.vectorstock.com/i/500p/08/19/gray-photo-placeholder-icon-design-ui-vector-35850819.jpg"
          }
        />
        <div
          style={{
            position: "absolute",
            right: 10,
            bottom: 45,
            background: "#fff",
            borderRadius: 3,
            cursor: "pointer",
          }}
          onClick={() => hiddenFileInput.current.click()}
        >
          <img width={30} src={require("../assets/icons/edit-image.png")} />
        </div>
        <input
          type="file"
          accept="image/png, image/jpeg"
          onChange={handleImageChange}
          ref={hiddenFileInput}
          style={{ display: "none" }}
        />
        <h3 className="text-center text-2xl capitalize mt-3">
          {data.username}
        </h3>
      </div>

      <div className="border-2 border-ddd mt-8 w-4/5 p-8 rounded-md mb-2">
        <div className="flex mb-7" style={{ justifyContent: "space-between" }}>
          <h3>Role</h3>
          <p className="text-gray-500">{data.position}</p>
        </div>
        <div className="flex mb-7" style={{ justifyContent: "space-between" }}>
          <h3>Email Address</h3>
          <p className="text-gray-500">{data.email}</p>
        </div>
        <div className="flex mb-7" style={{ justifyContent: "space-between" }}>
          <h3>Registration Data</h3>
          <p className="text-gray-500">
            {new Date(data.createdAt)?.toLocaleDateString("tr-TR")}
          </p>
        </div>
        <div className="flex mb-7" style={{ justifyContent: "space-between" }}>
          <h3>Gender</h3>
          <input
            onFocus={(e) => e.target.select()}
            className="text-gray-500 focus:outline-none text-right"
            value={data.gender ? data.gender : "Set Now"}
            onChange={(e) => setData({ ...data, gender: e.target.value })}
          />
        </div>
        <div className="flex mb-7" style={{ justifyContent: "space-between" }}>
          <h3>Birthday</h3>
          <input
            onFocus={(e) => e.target.select()}
            className="text-gray-500 focus:outline-none text-right"
            value={data.birthday ? data.birthday : "Set Now"}
            onChange={(e) => setData({ ...data, birthday: e.target.value })}
          />
        </div>
        <div className="flex mb-7" style={{ justifyContent: "space-between" }}>
          <h3>Languages</h3>
          <input
            onFocus={(e) => e.target.select()}
            className="text-gray-500 focus:outline-none text-right"
            value={data.languages ? data.languages : "Set Now"}
            onChange={(e) => setData({ ...data, languages: e.target.value })}
          />
        </div>
        <div className="flex mb-7" style={{ justifyContent: "space-between" }}>
          <h3>Education</h3>
          <input
            onFocus={(e) => e.target.select()}
            className="text-gray-500 focus:outline-none text-right"
            value={data.education ? data.education : "Set Now"}
            onChange={(e) => setData({ ...data, education: e.target.value })}
          />
        </div>
        <div className="flex mb-7" style={{ justifyContent: "space-between" }}>
          <h3>Authenticated</h3>
          <p className="font-bold text-green-500">
            {data.confirmed ? "Yes" : "No"}
          </p>
        </div>
        <div className="flex mb-7" style={{ justifyContent: "space-between" }}>
          <h3>Posts</h3>
          <p className="text-gray-500">{data.posts ? data.posts : 0}</p>
        </div>
        <div className="flex mb-7" style={{ justifyContent: "space-between" }}>
          <h3>Words</h3>
          <p className="text-gray-500">{data.words ? data.likes : 0}</p>
        </div>
        <div className="flex mb-7" style={{ justifyContent: "space-between" }}>
          <h3>Likes</h3>
          <p className="text-gray-500">{data.likes ? data.likes : 0}</p>
        </div>
        <div className="" style={{}}>
          <h3>Certificates</h3>
          <div
            className="mt-2 flex gap-5"
            style={{ justifyContent: "flex-start" }}
          >
            {certif.map((item, index) => (
              <div key={index}>
                {index == certif.length - 1 ? (
                  <div
                    className="w-20 h-20 border-dashed border-2 border-gray-300 flex rounded-md cursor-pointer"
                    onClick={() => hiddenFileInput2.current.click()}
                  >
                    <AddCircleOutlineIcon className="text-gray-400" />
                  </div>
                ) : (
                  <div
                    className="relative w-20 h-20 rounded-md overflow-hidden cursor-pointer"
                    onClick={() => handleRemoveCertif(index)}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src={
                        item instanceof File
                          ? URL.createObjectURL(item)
                          : SERVER_DOMAIN + item
                      }
                    />
                    <div className="group absolute top-0 left-0 w-full h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                      <ClearIcon className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
          <input
            type="file"
            accept="image/png, image/jpeg"
            onChange={handleAddCertif}
            ref={hiddenFileInput2}
            style={{ display: "none" }}
          />
        </div>

        <div className="mt-8">
          <h3 className="mb-3">Social Media Accounts</h3>
          <div className="socialInputC">
            <img src={facebookIcon} />
            <TextField
              sx={{ width: 350 }}
              label="Facebook"
              variant="outlined"
              size="small"
              value={socials.fb}
              onChange={(e) => {
                setSocials({ ...socials, fb: e.target.value });
              }}
            />
          </div>
          <div className="socialInputC">
            <img src={xIcon} />
            <TextField
              sx={{ width: 350 }}
              label="X"
              variant="outlined"
              size="small"
              value={socials.x}
              onChange={(e) => {
                setSocials({ ...socials, x: e.target.value });
              }}
            />
          </div>
          <div className="socialInputC">
            <img src={linkedinIcon} />
            <TextField
              sx={{ width: 350 }}
              label="LinkedIn"
              variant="outlined"
              size="small"
              value={socials.li}
              onChange={(e) => {
                setSocials({ ...socials, li: e.target.value });
              }}
            />
          </div>
          <div className="socialInputC">
            <img src={instagramIcon} />
            <TextField
              sx={{ width: 350 }}
              label="Instagram"
              variant="outlined"
              size="small"
              value={socials.ig}
              onChange={(e) => {
                setSocials({ ...socials, ig: e.target.value });
              }}
            />
          </div>
        </div>

        <div className="" style={{ justifyContent: "space-between" }}>
          <h3>Bio</h3>
          <TextField
            sx={{ width: "100%" }}
            label=""
            placeholder="A short introduction about yourself"
            variant="outlined"
            multiline
            rows={7}
            value={data.bio || ""}
            onChange={(e) => setData({ ...data, bio: e.target.value })}
          />
        </div>
      </div>
      <SuccessAlert
        show={show}
        setShow={setShow}
        message={"The changes were saved successfully"}
      />
      <div
        className="w-5/12 h-12 bg-blue-600 hover:bg-blue-700 rounded-md flex text-white mt-2 cursor-pointer transition-all duration-200"
        onClick={submitData}
      >
        Save Changes
      </div>

      <div
        className="w-3/12 h-10 bg-red-500 hover:bg-red-600 rounded-md flex text-white mt-4 cursor-pointer transition-all duration-200"
        onClick={logOut}
      >
        Log Out
      </div>
    </div>
  );
}
